import React from 'react';

interface WhiteAngleIconProps {
  className?: string;
}

function WhiteAngleRegularIcon(props: WhiteAngleIconProps) {
  const { className = '' } = props;
  return (
    <svg
      className={className}
      fill="none"
      height="112"
      viewBox="0 0 101 112"
      width="101"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M44 89.5C31.5 108 11 112 0 112H101.5V0L44 89.5Z" fill="white" />
    </svg>
  );
}

export default WhiteAngleRegularIcon;
